import React, { useCallback, useState } from 'react';
import { observer } from 'mobx-react-lite';

import { useStore, useTranslation } from '../../../../../../../../hooks';
import { T } from '../../../../../../../../constants';

import './style.scss';

const COPIED_RESET_DELAY = 2000;

export const ReplayFramePopup: React.FC = observer(() => {
  const t = useTranslation();
  const { gameStore, postMessageStore, sidebarMenuStore } = useStore();
  const { isDemo, replayWin, isReplayFinished, hasGameRedirection, gameReplayUrl: { data: replayUrl } } = gameStore;

  const [isCopied, setIsCopied] = useState(false);

  const refCallback = useCallback((element: HTMLIFrameElement) => {
    postMessageStore.setReplayIframeElement(element);
  }, []);

  if (!replayWin) return null;

  const handleBack = () => gameStore.closeReplay();

  const handleClose = () => {
    gameStore.closeReplay();
    sidebarMenuStore.setIsSidebarOpen(false);
  };

  const handlePlayNow = () => gameStore.playReplayGame(replayWin);

  const handleWatchAgain = () => {
    postMessageStore.sendWatchAgain();
    gameStore.setIsReplayFinished(false);
  };

  const handleCopyUrl = () => {
    if (!replayUrl) return;
    navigator.clipboard?.writeText(replayUrl).then(() => {
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), COPIED_RESET_DELAY);
    }).catch(() => {});
  };

  const playText = t(isDemo ? T.PLAY_DEMO : T.PLAY_NOW);

  return (
    <div className="copy-popup-wrapper">
      <div className="copy-popup-content">
        <div className="copy-popup-header">
          <button type='button' className="copy-popup-header-button" onClick={handleBack}>
            <i className="icon-arrow-left" />
          </button>
          <p className="copy-popup-header-title">{t(T.BET_ID)}: {replayWin.betId}</p>
          <button type='button' className="copy-popup-header-button" onClick={handleClose}>
            <i className="icon-close" />
          </button>
        </div>
        <div className="copy-popup-body-wrapper">
          {!!replayUrl && (
            <iframe
              ref={refCallback}
              src={replayUrl}
              className="replay-frame-iframe"
              title="Pascal Gaming Replay Frame"
              allow="fullscreen"
            />
          )}
          {isReplayFinished && (
            <div className="replay-frame-actions">
              <div className="copy-popup-body">
                {/* the play button launches the winner's game, so it only exists where the partner supports game redirection */}
                {hasGameRedirection && (
                  <button type='button' className="copy-popup-button play-button" onClick={handlePlayNow}>
                    <i className="icon-play copy-popup-button-icon-play" />
                    <span className="copy-popup-button-name">{playText}</span>
                  </button>
                )}
                <button type='button' className="copy-popup-button again-button" onClick={handleWatchAgain}>
                  <i className="icon-replay-cards copy-popup-button-icon" />
                  <span className="copy-popup-button-name">{t(T.WATCH_AGAIN)}</span>
                </button>
              </div>
              <div className="copy-popup-footer">
                <button type='button' className="copy-popup-button copy-button" onClick={handleCopyUrl}>
                  <i className={`${isCopied ? 'icon-check' : 'icon-link'} copy-popup-button-icon`} />
                  <span className="copy-popup-button-name">{t(isCopied ? T.COPIED : T.COPY_URL)}</span>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
});
